import { addDays } from 'lib/dateUtils'

export function setAppBannerCookie() {
  const in1Week = addDays(new Date(), 7)
  document.cookie = `appBanner=${in1Week}; expires=${in1Week}; path=/; domain=${document.domain}`
}
